import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

const NotificationContext = createContext(null);

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const [state, setState] = useState({
    open: false,
    message: '',
    severity: 'info', // 'success' | 'info' | 'warning' | 'error'
    duration: 6000,
    position: { vertical: 'top', horizontal: 'center' }
  });

  const showNotification = useCallback((message, severity = 'info', options = {}) => {
    setState(prev => ({
      ...prev,
      open: true,
      message,
      severity,
      duration: options.duration || 6000,
      position: options.position || { vertical: 'top', horizontal: 'center' }
    }));
  }, []);

  const hideNotification = useCallback((event, reason) => {
    if (reason === 'clickaway') return;
    setState(prev => ({ ...prev, open: false }));
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification, hideNotification }}>
      {children}
      <Snackbar
        open={state.open}
        autoHideDuration={state.duration}
        onClose={hideNotification}
        anchorOrigin={state.position}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={hideNotification}
          severity={state.severity}
          sx={{ width: '100%', mt: 8 }}
        >
          {state.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};
